// extracted by mini-css-extract-plugin
module.exports = {"container":"modal_confirmation_content-module--container--1OH_0"};